import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'

type BoardStandardColumnResourceV3 = OpalApiComponent<
  'V3',
  'board_standard_column'
>

export const boardStandardColumnResourceFactory: Factory<BoardStandardColumnResourceV3> =
  Factory.define<BoardStandardColumnResourceV3>(({ sequence }) => {
    return {
      id: uuidV4(),
      type: 'board_standard_column',
      attributes: {
        system_name: `standard_column_${sequence}`,
        display_name: `Standard Column ${sequence}`,
        default_position: sequence,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
    } satisfies BoardStandardColumnResourceV3
  })
